/**
 * Represents a single map marker for the Search Results map widget
 *
 * This directly extends from the Google Maps Marker object
 * @param {SearchMap} map     The map to attach to
 * @param {Object} listing    A single search result
 */
function SearchMapMarker(map, listing) {
    this.map = map;
    this.listing = listing;
    this.markerType = 'single';

    this.locationInfo = new google.maps.InfoWindow({
          content: 'Actual location within .25 mile radius.'
    });

    this.fuzzyCircle = this.getFuzzyCirle(listing.lat, listing.lng);

    var markerOptions = {
        map: this.map,
        icon: this.getMarkerImage(),
        position: new google.maps.LatLng(listing.lat, listing.lng)
    };

    if(listing.Title !== null) {
        markerOptions.title = listing.title;
    }

    //Construct the parent
    google.maps.Marker.call(this, markerOptions);

    this.addListeners();
}

if(typeof google.maps.Marker === undefined) {
    console.error("Google Maps Marker library was not found");
}

//Extend the Google Maps marker
SearchMapMarker.prototype = Object.create(google.maps.Marker.prototype);
SearchMapMarker.prototype.constructor = google.maps.Marker;

/**
 * Adds event listeners for when the marker is clicked or hovered
 */
SearchMapMarker.prototype.addListeners = function() {
    // Open infobox when marker is clicked
    google.maps.event.addListener(this, 'click', this.evtMarkerClick.bind(this));

    google.maps.event.addListener(this, 'mouseover', this.evtMarkerHover.bind(this));
    google.maps.event.addListener(this, 'mouseout', this.evtMarkerHoverLeave.bind(this));
};

/**
 * Bounce the marker once and bring it to the foreground
 */
SearchMapMarker.prototype.bounce = function() {
    var listing = $(".listing[data-unitid=" + this.listing.unitID + "] .mod-listing").get(0);

    this.setAnimation(google.maps.Animation.BOUNCE);
    this.setIcon(this.getMarkerImage(true));
    // When user leaves hover state on listing, color goes from orange to white
    $(listing).mouseleave(function() {
        this.setIcon(this.getMarkerImage(false));
    }.bind(this));

    window.setTimeout(function () {
        this.setAnimation(null);
    }.bind(this), 700);

    this.setZIndex(google.maps.Marker.MAX_ZINDEX + 1000);

};

/**
 * When an event marker is clicked, open an InfoWindow displaying listing information
 */
SearchMapMarker.prototype.evtMarkerClick = function(evt) {
    var listing = $(".listing[data-unitid=" + this.listing.unitID + "] .mod-listing");

    if(listing[0]) {
        // Copy the listing's content
        preSlide = listing.data('initSlide');
        this.infoWindow.close();
        this.infoWindow.setContent(preSlide);
        this.infoWindow.open(this.map, this);

        var uid = this.listing.unitID;
        google.maps.event.addListener(this.infoWindow,'domready',function(){
            $('.info-box').find(".listing-img-container .flexslider").removeClass("flexslider-listing").addClass("flexslider-single");
            
            $('.flexslider-single').flexslider({
                controlNav: false,
                slideshow: false,
                animationSpeed: 200,
                keyboard: false,
                
                // lazy load carousel images
                start: function(slider) { // Fires when the slider loads the first slide
                  var slide_count = slider.count - 2;

                  $(slider).find('img.lazy:eq(0), img.lazy:eq(' + slide_count + ')').each(function() {
                      var src = $(this).attr('data-src');
                      $(this).attr('src', src).removeAttr('data-src');
                    });
                },
                before: function(slider) { // Fires asynchronously with each slider animation
                  var slides     = slider.slides,
                      next       = slider.animatingTo,
                      $slide     = $(slides[next]),
                      $img       = $slide.find('img[data-src]'),
                      nxt_slide  = next,
                      prev_slide = next - 2;

                  $slide.parent().find('img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')').each(function() {
                      var src = $(this).attr('data-src');
                      $(this).removeAttr('data-src').attr('src', src);
                      $(this).parent().addClass('flex-slide');
                    });
                }
            });
        });
    }
};

/**
 * Hover on Marker highlights corresponding listing
 */
SearchMapMarker.prototype.evtMarkerHover = function(evt) {
    // Update marker icon with image stack
    this.setIcon(this.getMarkerImage(true));

    if(this.listing.fuzzy) {
        this.fuzzyCircle.setVisible(true);
        this.locationInfo.open(this.map, this);
    }

};

/**
 * Resetting marker image and z-index
 */
SearchMapMarker.prototype.evtMarkerHoverLeave = function(evt) {
    var image = this.getMarkerImage();

    // Updating marker icon with image stack
    this.setIcon(image);

    // Lets remove the circle from the Addressless marker
    if(this.listing.fuzzy) {
        this.fuzzyCircle.setVisible(false);
        this.locationInfo.close();
    }

};

/**
 * Generates a Vacasa-branded marker image for displaying on the screen
 * @param  {boolean} hovered If the image should represent the hover state for the marker
 * @return {Object}          An object describing the image attributes
 */
SearchMapMarker.prototype.getMarkerImage = function(hovered) {
    var url = 'https://d33zkqzv7i9ae0.cloudfront.net/images/marker_pins_gray.png';
    var size = new google.maps.Size(28, 43);
    var anchor = new google.maps.Point(14, 40);
    var scaledSize;
    var origin;
    var customPin;

    // Setting Scaling
    if(window.devicePixelRatio <= 1) {
        // Non-Retina
        scaledSize = new google.maps.Size(280, 328);
    } else {
        // Retina
        scaledSize = new google.maps.Size(140, 164);
    }

    // Normal Marker
    if(window.devicePixelRatio <= 1){
        // Non-Retina
        // Brown
        origin = new google.maps.Point(0,164);
        customPin = new google.maps.Point(224,164); // Red
    } else {
        // Retina
        // Brown
        origin = new google.maps.Point(0,0);
        customPin = new google.maps.Point(112,41); // Red
    }

    // Inactive Marker
    if(!this.listing.active) {
        if(window.devicePixelRatio <= 1){
            // Non-Retina
            // Grey
            origin = new google.maps.Point(168,164);
        } else {
            // Retina
            // Grey
            origin = new google.maps.Point(84,0);
        }
    }

    if(hovered) {
        // Normal Selected Marker
        if(window.devicePixelRatio <= 1) {
            // Non-Retina
            // Brown Selected
            origin = new google.maps.Point(0,246);
        } else {
            // Retina
            // Brown Selected
            origin = new google.maps.Point(0,41);
        }

        // Inactive Selected Marker
        if(!this.listing.active){
            if(window.devicePixelRatio <= 1){
                // Non-Retina
                // Grey Selected
                origin = new google.maps.Point(168,246);
            } else {
                // Retina
                // Grey Selected
                origin = new google.maps.Point(84,41);
            }
        }
    }

    if(this.listing.fuzzy) {
        // Dots for homes that dont have an address
        // Changing image, size, and anchor points
        url = 'https://d33zkqzv7i9ae0.cloudfront.net/images/marker_dots_gray.png';
        anchor = new google.maps.Point(14, 14);
        size = new google.maps.Size(28, 29);
    }

    // All the things that make up the marker image
    var image = {
        url: url,
        size: size,
        scaledSize: scaledSize,
        origin: origin,
        anchor: anchor
    };

    return image;
};

/**
 * Generates a Vacasa-branded circle for markers with an approximate location
 * @param  {float} lat The latitute where the circle should appear
 * @param  {float} lng The longitude where the circle should appear
 * @return {google.maps.Circle}     An instantiated Circle object for rendering
 */
SearchMapMarker.prototype.getFuzzyCirle = function(lat, lng) {
    // // Lets add a circle to the Addressless marker
    circleOptions = {
        strokeColor: '#FCD700',
        strokeOpacity: 0.75,
        strokeWeight: 2,
        fillColor: '#FCD700',
        fillOpacity: 0.25,
        map: this.map,
        visible: false,
        center: new google.maps.LatLng(lat, lng),
        radius: 403 // in meters ~ .25 mile
    };

    return new google.maps.Circle(circleOptions);
};

window.SearchMapMarker = SearchMapMarker;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchMapMarker.js
// module id = 10
// module chunks = 0